<!--suppress UnnecessaryLabelJS -->
<template>
	<div>
		<filters
			@chosen-companies="chosenCompanies = $event"
			@chosen-dates="chosenDates = $event"
		/>
		<div>
			מספר המשחקים: <span>{{ gamesFiltered.length }}</span>
		</div>
		<v-btn @click="exportExcel">
			<v-icon>fa-file-download</v-icon>
			ייצוא לאקסל
		</v-btn>
		<v-data-table
			:headers="headers"
			:items="gamesFiltered"
			:loading="loading"
			class="elevation-1"
			:mobile-breakpoint="0"
			sort-by="played_at"
			:sort-desc="true"
		>
			moment
			<v-progress-linear slot="progress" color="blue" indeterminate />
			<template #item="{item}">
				<game-log-row :key="item.id" :game-log="item" />
			</template>
			<!--			<game-log-row slot="item" slot-scope="props" :gameLog="props.item"/>-->
		</v-data-table>
	</div>
</template>

<script>
import GameLogRow from "src/view/gamelogs/GameLogRow";
import { types } from "src/store/modules/GameLog.module";
import FilterAble from "src/mixins/FilterAble";
import filters from "dev/view/gamelogs/filters";
import moment from "moment";
import { json2excel } from "js2excel";

export default {
	name: "GamelogsTable",
	components: {
		GameLogRow,
		filters
	},
	props: [],
	mixins: [new FilterAble(types)],
	data() {
		return {
			loading: false,
			headers: [
				{ text: "שם המרכז", value: "company.name" },
				{ text: "שם המשחק", value: "game.name" },
				{ text: "תאריך משחק", value: "played_at" }
			],
			search: null,
			chosenCompanies: [],
			chosenDates: [],
			range: {},
			showDialog: false
		};
	},
	computed: {
		gameLogs() {
			return this.$store.state.GameLogModule.gamelogs;
		},
		gamesFiltered() {
			let filtered = [];
			if (!this.chosenCompanies.length) {
				filtered = this.gameLogs;
			} else {
				filtered = this.gameLogs.filter(game => {
					return this.chosenCompanies.includes(game.company_id);
				});
			}
			/* filter by date range */
			if (this.chosenDates.length) {
				const start = moment(this.chosenDates[0]);
				const end = moment(this.chosenDates[1]);
				filtered = filtered.filter(game => {
					const playDate = moment(game.played_at);
					return playDate.isBefore(end) && playDate.isAfter(start);
				});
			}

			return filtered;
		},
		gamesToExport() {
			return this.gamesFiltered
				.filter(game => game.game && game.company)
				.map(game => {
					return {
						game: game.game.name,
						center: game.company.name,
						date: moment(game.played_at).toDate()
					};
				});
		}
	},
	methods: {
		exportExcel: function() {
			const data = this.gamesToExport;
			try {
				json2excel({
					data: data,
					name: "טבלת משחקים",
					formateDate: "d/m/yyyy hh:ss"
				});
			} catch (e) {
				console.error(e);
			}
		}
	}
};
</script>

<style></style>
